import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1015"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m1.19 11.716 1.338 2.816 1.391-2.816-1.391-1.498zm3.666 0 1.338 2.816 1.391-2.816-1.391-1.498zm3.666 0 1.337 2.816 1.392-2.816-1.392-1.498zm3.666 0 1.337 2.816 1.392-2.816-1.392-1.498zm1.787-6.67a2.933 2.933 0 0 0-1.75-1.13c-.178-1.577-1.452-2.741-2.859-2.762-1.123-.017-2.192.696-2.695 1.804a2.89 2.89 0 0 0-1.362.553 2.887 2.887 0 0 0-.878 1.082c-1.165-.155-1.991.454-2.353 1.181a1.713 1.713 0 0 0-1.207.131c-.49.259-.873.79-.873 1.414-.001.709.491 1.289 1.08 1.51.73.274 1.378-.09 1.468-.143.169.144.792.638 1.717.639a2.667 2.667 0 0 0 1.473-.45 3.9 3.9 0 0 0 2.195.368 3.865 3.865 0 0 0 1.665-.631 3.48 3.48 0 0 0 2.071.63 3.42 3.42 0 0 0 1.597-.449c.122.057.826.374 1.582.056.768-.323 1.194-1.135 1.156-1.874-.05-.968-.898-1.83-2.027-1.929z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }